import { render } from "./ReloadSpinnerTccDocs.vue?vue&type=template&id=68473447&scoped=true"
import script from "./ReloadSpinnerTccDocs.vue?vue&type=script&lang=js"
export * from "./ReloadSpinnerTccDocs.vue?vue&type=script&lang=js"

import "./ReloadSpinnerTccDocs.vue?vue&type=style&index=0&id=68473447&lang=scss&scoped=true"

import exportComponent from "C:\\Projects\\fxhub-ui\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68473447"]])

export default __exports__